
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    REVERT_RMA_GET_DEVICE_REQUEST,
    REVERT_RMA_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { revertRmaGetDeviceResult, revertRmaResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                    esn
                    imei
                    isRMA
                    status
                    simCard {
                        iccId
                        msisdn
                        simProviderAccount {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                    refurbishedUnit { 
                        refurbishedUnitId 
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(revertRmaGetDeviceResult(data?.result))
        } else {
            yield put(revertRmaGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(revertRmaGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/revertRma/redux/saga",
            "getDevice",
        )
    }
}

function* revertRma({ payload }) {
    try {

        let QUERY = `
            mutation revertRMAStatus ($unitIds: [Int]) {
               result: revertRMAStatus (unitIds: $unitIds)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(revertRmaResult({ revertRma: true }))
        } else {
            yield put(revertRmaResult({ revertRma: false }))
        }

    } catch (exc) {
        yield put(revertRmaResult({ revertRma: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/revertRma/redux/saga",
            "revertRma",
        )
    }
}

function* watchMethods() {
    yield takeEvery(REVERT_RMA_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(REVERT_RMA_REQUEST, revertRma);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}